/* sugar:assets/product-subtotals.js@2.2.0 */
/*
 * product-subtotals — paints the savings and subtotal rows from the shared price store.
 *
 * The rows arrive already filled from Liquid, so the first paint is correct before this file
 * runs. All this does is keep them in step when a variant, a quantity, an offer tier or a
 * subscription moves — using the same store the Product Price block reads, so the two can
 * never show different numbers.
 */
(function () {
  const RECEIPT_TEST = /\[(tier_title|compare_subtotal|savings_total|s)\]/;

  /*
   * Numbers from "the page's buy box": a block outside the product section follows that
   * section's tier and purchase type (the way a sticky bar's buy button does).
   */
  function buyboxSectionId(root, config) {
    const own = root.closest('.shopify-section');
    if (own && own.querySelector('.offer, [data-bundle-builder], [data-sugar-subscriptions], product-form')) return config.sectionId;
    const main = document.querySelector('product-info[data-section][data-product-id="' + config.productId + '"]');
    return main ? main.dataset.section : config.sectionId;
  }

  function subscriptionsPlan(sectionEl) {
    const subs = sectionEl && sectionEl.querySelector('[data-sugar-subscriptions]');
    if (!subs) return null;
    if (subs.sugarSubscriptions && subs.sugarSubscriptions.plan) return subs.sugarSubscriptions.plan;
    try {
      const plans = JSON.parse((subs.querySelector('[data-sb-plans]') || {}).textContent || '[]');
      return plans[0] || null;
    } catch (e) {
      return null;
    }
  }

  /*
   * "As a subscription": the selected tier's subscription total (offers.js publishes it on every
   * tier, whatever is picked), against the tier's one-time compare price; with no tiers, the
   * variant on the Subscriptions block's plan.
   */
  function asSubscription(sectionEl, state) {
    const offer = sectionEl && sectionEl.querySelector('.offer.is-selected');
    const subTotal = offer ? parseInt(offer.dataset.computedSubTotalPrice, 10) : NaN;
    if (Number.isFinite(subTotal)) {
      const compare = parseInt(offer.dataset.computedOneTimeComparePrice, 10);
      const totalCompare = Math.max(Number.isFinite(compare) ? compare : state.oneTimeCompare || 0, subTotal);
      return Object.assign({}, state, { totalPrice: subTotal, totalCompare, onSale: totalCompare > subTotal });
    }
    const plan = subscriptionsPlan(sectionEl);
    const unit = plan ? window.SugarPricing.applySellingPlan(state.baseUnit, plan) : state.baseUnit;
    const quantity = state.quantity || 1;
    const totalPrice = unit * quantity;
    const totalCompare = Math.max((state.baseCompareUnit > 0 ? state.baseCompareUnit : state.baseUnit) * quantity, totalPrice);
    return Object.assign({}, state, { totalPrice, totalCompare, unitPrice: unit, onSale: totalCompare > totalPrice });
  }

  function tierTitle(sectionEl) {
    const title = sectionEl && sectionEl.querySelector('.offer.is-selected .offer__title');
    return title ? title.textContent.trim() : '';
  }

  function mount(island) {
    if (island.dataset.mounted) return;
    island.dataset.mounted = 'true';

    let config;
    try {
      config = JSON.parse(island.textContent);
    } catch (e) {
      return;
    }

    const root = document.querySelector('[data-_sf="' + config.blockId + '"]');
    if (!root || !window.SugarPricing) return;

    const savingsRow = root.querySelector('[data-savings-row]');
    const mode = config.numbersFrom || 'section';
    const extra = parseInt(config.extra, 10) || 0;

    /*
     * Only the labels that actually contain a token get repainted. A plain "Subtotal" is
     * server-rendered once and never touched again.
     */
    const targets = [];
    root.querySelectorAll('[data-template]').forEach((el) => {
      const tpl = el.dataset.template;
      if (window.SugarPricing.hasTokens(tpl) || RECEIPT_TEST.test(tpl) || (window.SugarPricing.hasPerTokens && window.SugarPricing.hasPerTokens(tpl))) targets.push(el);
    });

    const sectionId = mode === 'section' ? config.sectionId : buyboxSectionId(root, config);
    const store = window.SugarPricing.store(sectionId === config.sectionId ? config : Object.assign({}, config, { sectionId }));

    store.subscribe(function (live) {
      const state = mode === 'subscription' ? asSubscription(store.sectionEl, live) : live;
      /* Nothing saved, nothing to say. */
      if (savingsRow) savingsRow.hidden = state.totalCompare + extra <= state.totalPrice;

      const money = (cents) => window.SugarPricing.formatMoney(cents, config.format);
      const tier = tierTitle(store.sectionEl);
      for (let i = 0; i < targets.length; i++) {
        const tpl = targets[i].dataset.template
          .replace(/\[tier_title\]/g, tier)
          .replace(/\[compare_subtotal\]/g, money(state.totalCompare + extra))
          .replace(/\[savings_total\]/g, money(Math.max(0, state.totalCompare - state.totalPrice) + extra))
          .replace(/\[s\]/g, '<s>')
          .replace(/\[\/s\]/g, '</s>');
        const html = window.SugarPricing.fillTokens(tpl, state, config.format);
        if (targets[i].innerHTML !== html) targets[i].innerHTML = html;
      }
    });

  }

  function init() {
    document.querySelectorAll('script[data-sugar-subtotals]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Section rendering swaps the markup out from under us in the theme editor. */
  document.addEventListener('shopify:section:load', init);
})();
